import _ from 'lodash';
import { getData } from '../../repository/dashboard-client/index';

const state = {
  clientData: null,
  dialogVisibility: false,
};

const getters = {
  spaceUsed: state => _.get(state, 'clientData.space_used', false),
  spaceAvailable: state => _.get(state, 'clientData.space_available', false),
  spaceUsedPercent: state => _.get(state, 'clientData.space_used_percent', false),
  subscriptionExpirationDate: state => _.get(state, 'clientData.subscription_expiration_date', false),
  subscriptionExpirationDay: state => _.get(state, 'clientData.subscription_expiration_day', false),
  subscriptionExpirationYear: state => _.get(state, 'clientData.subscription_expiration_year', false),
  subscriptionExpirationMonth: state => _.get(state, 'clientData.subscription_expiration_month', false),
  daysToExpire: state => _.get(state, 'clientData.days_to_expire', false),
  filesCount: state => _.get(state, 'clientData.files_count', false),
  directoriesCount: state => _.get(state, 'clientData.directories_count', false),
  dialogVisibility: state => state.dialogVisibility,
};
const mutations = {
  SET_CLIENT_DATA(state, clientData) {
    state.clientData = clientData;
  },
  SET_DIALOG_VISIBILITY(state, type) {
    state.dialogVisibility = type;
  },
};
const actions = {
  async getClientData({ commit }) {
    commit('SET_CLIENT_DATA', null);
    const response = await getData();
    commit('SET_CLIENT_DATA', _.get(response, 'data.data', null));
  },
  setDialogVisbility({ commit }, type) {
    commit('SET_DIALOG_VISIBILITY', type);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
